import { createFlags } from 'flag';

import { createReduxBindings } from 'flag/redux';

// flags library set up
export const { Flag, FlagsProvider } = createFlags();
export const { ConnectedFlagsProvider, createFlagsReducer, setFlagsAction } =
  createReduxBindings(FlagsProvider);
